'use client'
import React from 'react'
import styles from './styles.module.scss'

const DividedLine: React.FC = () => {
  return <hr className={styles.dividedLine} />
}

export default DividedLine
